import { createStyles } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';

const styles: any = makeStyles(() =>
    createStyles({
        root: {
            position: 'relative',
        },
    }),
);

export default styles;
